<template>
  <div class="food-booking mt40 w100">
    <div class="content">
      <div class="cont-wrap">
        <div class="til mb20">填写订单信息</div>
        <div class="flex">
          <div class="contact-info w150px">预订信息</div>
          <el-table class="confirm-table" :data="tableData" style="width: 100%">
            <el-table-column
              align="center"
              prop="industryName"
              label="餐厅名称"
            />
            <el-table-column align="center" prop="name" label="产品名称" />
            <el-table-column align="center" prop="salePrice" label="单价">
              <template slot-scope="scope">
                <span>¥{{scope.row.salePrice}}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="isValidDate"
              label="有效时间"
              width="180"
            />
            <el-table-column align="center" label="数量" width="180">
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.quantity"
                  :min="0"
                  size="mini"
                  @change="handleQty(scope.$index, scope.row)"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="totalPrice" label="总价">
              <template slot-scope="scope">
                <span>¥{{scope.row.totalPrice}}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-divider class="divider"></el-divider>
        <div class="flex">
          <div class="contact-info w150px">联系人信息</div>
          <el-form ref="form" :model="orderInfo" label-width="90px">
            <el-form-item
              label="手机号码:"
              prop="contactMobile"
              :rules="[{ required: true, validator: checkPhone }]"
            >
              <el-input placeholder="请输入联系人手机号码" v-model="orderInfo.contactMobile"></el-input>
              <span class="flex-align-center">
                <img
                  class="tip-icon"
                  src="../../assets/imgs/tip-icon.png"
                  alt=""
                />
                <span>请精确填写，以免无法接收信息</span>
              </span>
            </el-form-item>
          </el-form>
        </div>
        <div class="sum">
          <div class="qty">
            数量
            <span>共<em>{{ totalNum }}</em>张</span>
          </div>
          <div class="price">
            总价 <span>￥{{ totalAmount.toFixed(2) }}</span>
          </div>
          <div class="buy-btn"><el-button @click="handleToBuy" v-loading.fullscreen.lock="fullscreenLoading">立即购买</el-button></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loadSaleList, createGeneralOrder } from '@/api/food/foodDetail'
import { config } from '@/constant/config'
import { validaCellPhone } from '@/utils/validate'

export default {
  name: 'foodBooking',
  data () {
    return {
      totalNum: 0,
      totalAmount: 0,
      tableData: [],
      fullscreenLoading: false,
      orderInfo: {},
      moduleType: 'FOOD'
    }
  },
  created () {
    this.id = this.$route.query.id
    this.merchIndustryId = this.$route.query.merchIndustryId
    if (this.id) {
      this.loadInfo()
    }
  },
  methods: {
    checkPhone  (rule, value, callback) {
      if (value) {
        if (validaCellPhone(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的联系手机号'))
        }
      } else {
        callback(new Error('请输入正确的联系手机号'))
      }
    },
    handleToBuy () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.flag) {
            return
          }
          let flagnum = false
          this.tableData.forEach(val => {
            if (val.quantity > 0) {
              flagnum = true
            }
          })
          console.log(flagnum)
          if (!flagnum) {
            this.$message.error('请选择购买数量')
            return
          }
          this.fullscreenLoading = true
          const data = this.tableData.filter(val => val.quantity > 0)
          this.flag = true
          const orderData = {
            contactMobile: this.orderInfo.contactMobile,
            tenantId: config.TENANTID,
            merchId: config.MERCHID,
            goodsId: data[0].id,
            quantity: data[0].quantity,
            orderType: '0'
          }
          createGeneralOrder(orderData).then(res => {
            if (res.code === 0) {
              this.orderNo = res.data
              this.$router.push({
                path: '/payOrderNew',
                query: {
                  orderNo: this.orderNo,
                  moduleType: this.moduleType
                }
              })
            } else {
              this.flag = false
              this.fullscreenLoading = false
              this.$message.error(res.error)
            }
          })
        }
      })
    },
    handleQty (index, info) {
      let list = JSON.parse(JSON.stringify(this.tableData))
      const someBoolean = list.some(item => item.quantity > 0 && item.id !== info.id)
      if (someBoolean) {
        this.$message.warning('一笔订单只能购买一种')
        list[index].quantity = 0
        this.tableData = list
        return
      }
      list[index].totalPrice = (info.salePrice * info.quantity).toFixed(2)
      this.totalNum = 0
      this.totalAmount = 0
      list.forEach((val) => {
        if (val.quantity > 0) {
          this.totalNum += parseInt(val.quantity)
        }
        if (val.totalPrice > 0) {
          this.totalAmount += parseFloat(val.totalPrice)
        }
      })
      this.tableData = list
    },
    loadInfo () {
      const data = {
        tenantId: config.TENANTID,
        merchId: config.MERCHID,
        merchIndustryId: this.merchIndustryId
      }
      loadSaleList(data).then((res) => {
        if (!res.data) {
          return
        }
        this.tableData = res.data.filter((val) => val.id === this.id)
        this.tableData.forEach((item, index) => {
          item.quantity = 1
          item.totalPrice = 0
          if (item.validStartDate && item.validEndDate) {
            item.isValidDate = item.validStartDate + '~' + item.validEndDate
          } else {
            item.isValidDate = '永久有效'
          }
          this.handleQty(index, item)
        })
      })
    }
  }
}
</script>
<style lang="scss">
.food-booking {
  min-height: 100vh;
  background: #f5f6f9;
  .content {
    // width: 1279px;
    margin: 0 auto;
    padding-bottom: 130px;

    .top {
      position: relative;
      height: 76px;
      margin-bottom: 24px;
    }

    .cont-wrap {
      max-width: 1279px;
      margin: 0 auto;
      padding: 40px 70px;
      box-sizing: border-box;
      background: #ffffff;
      box-shadow: 0px 3px 16px rgba(24, 60, 80, 0.08);
      opacity: 1;
      border-radius: 8px;

      .til {
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 26px;
        color: #9b232a;
      }

      .block {
        margin-top: 28px;
        .sub-til {
          line-height: 21px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          line-height: 21px;
          color: #242b34;
          img {
            width: 24px;
            height: 24px;
            margin-right: 8px;
            vertical-align: middle;
            transform: translateY(-2px);
          }
        }

        .list {
          display: flex;
          margin-top: 6px;
          justify-content: space-between;
          align-items: center;
          span,
          .other {
            flex: 1;
            margin-right: 109px;
            padding: 9px 20px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            line-height: 24px;
            color: #44516f;
            border: 1px solid #95a3af;
            text-align: center;
            border-radius: 4px;
            cursor: pointer;
            &.active {
              color: #1d263a;
              font-weight: bold;
              border-color: #9b232a;
              background: url(../../assets/imgs/choosed-icon.png) no-repeat
                bottom right;
              background-size: 18px 18px;
            }
          }

          .other {
            margin-right: 0;
            background: #9b232a;
            color: #fff;
            input {
              height: 24px;
              padding: 0;
              background: #9b232a;
              border: none;
              text-align: center;
              color: #fff;
              font-weight: normal;
              &::input-placeholder,
              &::-webkit-input-placeholder,
              &::-moz-placeholder {
                color: #fff;
              }
            }
            .el-input__suffix,
            .el-input__prefix {
              display: none;
            }
          }

          &.qty {
            span {
              margin-right: 71px;
              &:last-child {
                margin-right: 0;
              }
            }
          }

          &.stock {
            margin-top: 0;
            span {
              padding: 0;
              border: none;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #3d5085;
              &:last-child {
                background: #fff;
              }
            }
          }
        }
      }

      .confirm-table {
        margin-top: 12px;
        margin-bottom: 44px;
      }

      .contact-info {
        margin-bottom: 24px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #424855;
        span {
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #424855;
          vertical-align: middle;
        }
      }

      .el-form {
        .el-form-item__label {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #0c121d;
        }
        .el-input {
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #1e2431;
        }
      }

      .sum {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #687280;

        .qty {
          span {
            margin-left: 10px;
            font-size: 20px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #424855;
            letter-spacing: 4px;
            em {
              color: #9b232a;
              font-style: normal;
            }
          }
        }

        .price {
          margin-left: 40px;
          span {
            font-size: 20px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #ff4400;
          }
        }

        .buy-btn {
          margin-left: 30px;
          width: 140px;
          height: 44px;
          .el-button {
            width: 100%;
            height: 100%;
            background: #9b232a;
            border-radius: 4px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #ffffff;
          }
        }
      }
    }
  }
  .tip-icon {
    width: 16px;
    height: 16px;
    margin-right: 5px;
  }
  .w150px {
    width: 150px;
    margin-top: 10px;
  }
}
.qrCode {
  padding-top: 20px;
  text-align: center;
}

.qrCode .img {
  display: inline-block;
  width: 200px;
  height: 200px;
}
</style>
